import styled from 'styled-components'

import Category from './Category'
import CommonActions from './CommonActions'
import DueDate from './DueDate'

const StyledFooterWrap = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 10px;
`

const StyledLabelContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: -8px;
`

const StyledCommonActions = styled(CommonActions)`
  padding-left: 15px;
`

const StyledCategory = styled(Category)`
  margin-right: 10px;
  margin-bottom: 8px;
`

const StyledDueDate = styled(DueDate)`
  margin-bottom: 8px;
`

interface FooterProps {
  document?: object
  notification?: {
    category?: string
    priority?: string
    dueAt?: string
    dueTimestamp?: string
    metadata?: {
      priority?: number
      category?: string
    }
  }
  onDelete?(...args: unknown[]): unknown
  priority?: string
}

const Footer = ({ onDelete, notification, document }: FooterProps) => {
  return (
    <StyledFooterWrap>
      <StyledLabelContainer>
        {/* @ts-expect-error */}
        {notification.category && notification.priority && (
          // @ts-expect-error
          <StyledCategory priority={notification.priority} category={notification.category} />
        )}
        {/* @ts-expect-error */}
        {notification.priority && (
          <StyledDueDate
            // @ts-expect-error
            priority={notification.priority}
            // @ts-expect-error
            dueTimestamp={notification.dueAt || notification.dueTimestamp}
          />
        )}
      </StyledLabelContainer>
      {!!onDelete && <StyledCommonActions className={'common-actions'} actionHandler={onDelete} document={document} />}
    </StyledFooterWrap>
  )
}

Footer.defaultProps = {}

export default Footer
